import { baseUrl } from '../../utils/constants';

const fmtMoney = (n) => `$${Number(n).toLocaleString()}`;
const fmtCount = (n) => Number(n).toLocaleString();
const fmtPct = (n) => `${n}%`;

// { apiField: { id, format } }
export const apiFieldMap = {
  // Loans
  npv: { id: 'loans', format: fmtMoney },
  ledgerSummaries: { id: 'loans-disbursed', format: fmtMoney },
  activeBook: { id: 'loans-outstanding', format: fmtCount },
  activeBookZwd: { id: 'loans-zim', format: fmtCount },
  npvLedger: { id: 'loans-repayment', format: fmtPct },

  // Membership
  membership: { id: 'membership', format: fmtCount },
  contributions: { id: 'mem-retention', format: fmtMoney },
  activeMembers: { id: 'mem-active', format: fmtCount },
  movementSummary: { id: 'mem-new', format: fmtCount },
  byRegion: { id: 'mem-region', format: (n) => `${n} Branches` },

  // Insurance
  claimsStatistics: { id: 'insurance', format: fmtCount },
  unpaidClaims: { id: 'ins-premiums', format: fmtCount },
  claimsPaid: { id: 'ins-claims', format: fmtCount },
  arcturialReport: { id: 'ins-policies', format: fmtCount },
  claimsByType: { id: 'ins-ratio', format: fmtPct },

  // Hospitality
  tuckshopPerformance: { id: 'hospitality', format: fmtMoney },
  occupancyRate: { id: 'hosp-occupancy', format: fmtPct },
  roomRevenue: { id: 'hosp-revenue', format: fmtMoney },
  storesInventory: { id: 'hosp-events', format: fmtCount }
};

// Build { metricId: formattedValue } from an API JSON payload.
export const buildValueMap = (payload = {}) => {
  const out = {};

  Object.keys(apiFieldMap).forEach((field) => {
    const raw = payload[field];
    const cfg = apiFieldMap[field];

    if (typeof raw === 'number') {
      out[cfg.id] = cfg.format(raw);
    }
  });

  return out;
};

// Fetch the dashboard payload from the configured endpoint.
// Returns {} on any failure so the UI falls back to static defaults.
export const fetchDashboardValues = async () => {
  const url = `${baseUrl}/api/client/getDashboardFields`; // import.meta.env.VITE_DASHBOARD_API_URL;
  if (!url) return {};
  try {
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) return {};
    const json = await res.json();
    return buildValueMap(json.result);
  } catch (err) {
    console.warn('[dashboard-api] fetch failed, using static defaults:', err);
    return {};
  }
};
